module.exports = __webpack_public_path__ + "static/media/verification-img.88cedf1f.png";